import { fetch, buildQueryString } from '../utils/request';

const BOARDS_BASE = process.env.BOARDS_API;
const THEMES_BASE = process.env.TAGBOARD_LIVE_URL;

export function getUserTagboards(userId) {
  return fetch(`${BOARDS_BASE}/tagboards/${userId}`);
};

export function getUserTagboardList(userId, query = {}) {
  return fetch(`${BOARDS_BASE}/tagboards/${userId}/many${buildQueryString(query)}`);
};

export function getUserThemes(userId, query = {}) {
  return fetch(`${THEMES_BASE}/themes/${userId}${buildQueryString(query)}`);
}
